module.exports = __webpack_public_path__ + "static/media/comment.46809ba0.svg";